import { primitive } from 'styles/constants';
export default {
  wrapperColor: primitive.$greyOne,
};
